// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3nNpS","title":"AfterBackImages_title__1xLNL","images":"AfterBackImages_images__vhST6"};